export default __webpack_public_path__ + "static/media/footer-facebook.234e8569.svg";